require('./bootstrap');

import {createApp} from 'vue'
import { createRouter, createWebHistory, createMemoryHistory} from 'vue-router';
import { i18nVue } from 'laravel-vue-i18n'


const VueRouter = createRouter({
    history: createWebHistory(),
    routes: [
        { path: '/admin/system/blacklist', component: () => import('./components/blacklist/index.vue') },
        { path: '/admin/system/settings', component: () => import('./components/settings/index.vue') },
        { path: '/admin/clients', component: () => import('./components/client/index.vue') },
        { path: '/admin/payments', component: () => import('./components/payments/index.vue') },
        { path: '/admin/coupons', component: () => import('./components/coupons/index.vue') },
        { path: '/admin/notifications/sms', component: () => import('./components/notifications/sms/index.vue') },
        { path: '/admin/notifications/email', component: () => import('./components/notifications/email/index.vue') },
        { path: '/admin/orders', component: () => import('./components/order/OrderCalendar.vue') },
        { path: '/admin/motivation/cleaners-league', component: () => import('./components/motivation/cleaners-league/index.vue') },
        { path: '/admin/motivation/settings', component: () => import('./components/motivation/settings/index.vue') },
        { path: '/cleaner/orders', component: () => import('./components/order/OrderCalendar.vue') },
        { path: '/cleaner/motivation/cleaners-league', component: () => import('./components/motivation/cleaners-league/index.vue') },
        { path: '/secretary/orders', component: () => import('./components/order/OrderCalendar.vue') },
        { path: '/admin/services/extras', component: () => import('./components/extras/ExtrasInterface.vue') },
    ]
});

// user
import WorkingSchedule from "./components/user/WorkingSchedule";
import OffDays from "./components/user/OffDays";
import SearchPlace from "./components/user/SearchPlace";
import CleanerFilter from "./components/user/cleaner/CleanerFilter.vue";

// service
import AddWhatsIncluded from './components/service/AddWhatsIncluded';
import DurationDropdown from './components/service/DurationDropdown';
import OrderInterface from './components/service/OrderInterface';
import ExtrasInterface from './components/extras/ExtrasInterface';
import ServiceExtras from './components/extras/ServiceExtras';
import AddGiftValues from "./components/service/AddGiftValues.vue";
import DescriptionField from "./components/service/DescriptionField.vue";
import Upsells from "./components/service/Upsells.vue";

//settings
import CompanySettings from "./components/settings/CompanySettings.vue";
import BookingRules from "./components/settings/BookingRules.vue";
import Firewall from "./components/settings/Firewall.vue";


/*
 * helpers
 */
import ServiceQuantity from "./components/helpers/ServiceQuantity";
import VueGoogleMaps from '@fawmi/vue-google-maps';

import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
const VueTelInputOptions = {
    autoFormat: true,
    //autoDefaultCountry: true,
    defaultCountry : window.telCountry,
    mode: "international",
    //onlyCountries: ['LT', "GB", "US"],
    preferredCountries: String(window.telPreferredCountry).split(','),
    dropdownOptions: {
        showSearchBox: true,
        showDialCodeInList: true
    },
    validCharactersOnly: true
};

import CustomPagination from "./components/helpers/CustomPagination.vue";

// create app
const app = createApp({
    data() {
        return {
            popupModalShowing: false,
            popupModalId: 0
        };
    }
});

app.component('Bootstrap4Pagination', CustomPagination);
app.component('add-whats-included', AddWhatsIncluded);
app.component('add-gift-values', AddGiftValues);
app.component('duration-dropdown', DurationDropdown);
app.component('order-interface', OrderInterface);
app.component('extras-interface', ExtrasInterface);
app.component('service-extras', ServiceExtras);
app.component('service-upsells', Upsells);
app.component('working-schedule', WorkingSchedule);
app.component('search-place', SearchPlace);
app.component('off-days', OffDays);
app.component('service-quantity', ServiceQuantity);
app.component('cleaner-filter', CleanerFilter);
app.component('company-settings', CompanySettings)
app.component('booking-rules', BookingRules)
app.component('description-field', DescriptionField)
app.component('firewall-settings', Firewall)

app
    .use(VueTelInput, VueTelInputOptions)
    .use(VueRouter)
    .use(VueGoogleMaps, {
        load: {
            key: 'AIzaSyCLVReJTrsUwkRCzYjmhmhzZTui_coLVF0',
            libraries: "places",
            countries: [window.googleAutocompleteCountry],
            language: window.googleAutocompleteLanguage,
        }})
    .use(i18nVue, {
        lang: window.appLocale,
        resolve: lang => import(`../lang/${lang}.json`),
    })
    .mount('#app');
